<h2 mat-dialog-title>{{ ctx.title | translate }}</h2>

<mat-dialog-content>
    <p>{{ctx.text | translate }}</p>
    <app-loader [loading]="!!this.ctx.status?.uploading?.value" />
</mat-dialog-content>